import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MenuIcon, XIcon } from "lucide-react";
import { Button } from "./Button";
import { LOGO_URL, navLinks } from "../data/content";
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 border-b bg-ink/95 backdrop-blur transition-[border-color] duration-200 ease-out ${scrolled ? "border-ink-line" : "border-transparent"}`} data-id="element-133" data-mp="31bfchfp3gv5r">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-8" data-id="element-134" data-mp="3bb64naq6my2o">
        <a href="#inicio" className="flex items-center gap-3" aria-label="Fortis Sports Management, inicio" data-id="element-135" data-mp="3fcrqvmolwopj">
          <img src={LOGO_URL} alt="" className="h-14 w-14 object-contain mix-blend-lighten" data-id="element-136" data-mp="2wlm91fajw6kf" />
          <span className="leading-tight" data-id="element-137" data-mp="2rkq3kxajwccw">
            <span className="block text-base font-semibold tracking-wide text-paper" data-id="element-138" data-mp="2ro492eeih1ok">FORTIS</span>
            <span className="block text-[11px] tracking-[0.18em] text-gold" data-id="element-139" data-mp="2mohw862lhnga">SPORTS MANAGEMENT</span>
          </span>
        </a>

        <nav aria-label="Principal" className="hidden items-center gap-10 md:flex" data-id="element-140" data-mp="3fb2k2wjv3hf3">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm text-paper/80 transition-colors duration-150 ease-out hover:text-gold" data-id="element-141" data-mp="3adaj7d18okyr">
              {link.label}
            </a>)}
          <Button href="#contacto" className="px-5 py-2.5" data-id="element-142" data-mp="30klldkym35lw">
            Contactar
          </Button>
        </nav>

        <button type="button" className="rounded-md p-2 text-paper hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold md:hidden" aria-label={open ? "Cerrar menú" : "Abrir menú"} aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen(v => !v)} data-id="element-143" data-mp="3tb3kkaw7smu1">
          {open ? <XIcon className="h-6 w-6" data-id="element-144" data-mp="1hlnmaslgvtsc" /> : <MenuIcon className="h-6 w-6" data-id="element-145" data-mp="1mmbehhlfmgo5" />}
        </button>
      </div>

      <AnimatePresence data-id="element-146" data-mp="1mki53ujfpicg">
        {open && <motion.nav id="mobile-menu" aria-label="Móvil" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-ink-line bg-ink px-6 pb-6 md:hidden" data-id="element-147" data-mp="18mttldb9bnk2">
            <ul className="flex flex-col py-2" data-id="element-148" data-mp="2t2x4lbsv0fs2">
              {navLinks.map(link => <li key={link.href} data-id="element-149" data-mp="2y201ua2llhph">
                  <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-ink-line py-4 text-paper/90 hover:text-gold" data-id="element-150" data-mp="2y29qnubwpitl">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <Button href="#contacto" className="mt-4 w-full" onClick={() => setOpen(false)} data-id="element-151" data-mp="w5slo77lp4hu">
              Contactar
            </Button>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}